import LoaderSuspense from './_loader-suspense.js'
import Hideable from './_hideable.js'
import FlexPane from './_flex-pane.js'
import MenuRowSkeleton from './_menu-row-skeleton.js'
import MenuRow from './_menu-row.js'
import SportIcons from './_sport-icons.js'

export default {
  name: 'InPlayMenu',
  values: {
    redirect: true,
    skeletonLoader: {
      configSet: LoaderSuspense,
      configValues: {
        style: {
          container: {
            maxWidth: '100%',
          },
        },
      },
    },
    autoSelectAllItem: true,
    allItem: {
      configSet: Hideable,
      configValues: {},
    },
    showStreamingItemLast: false,
    rootContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '0 0px 8px 0px',
          _mobile_padding: '8px 8px 0 8px',
          boxSizing: 'border-box',
          maxWidth: '100%',
        },
      },
    },
    navigationMenuSkeleton: {
      configSet: MenuRowSkeleton,
      configValues: {
        container: {
          itemSpacing: '8px',
          style: {
            padding: '0px',
            _desktop_flexGrow: 0,
          },
        },
        linkPlaceholder: {
          style: {
            width: '88px',
            height: '40px',
          },
        },
      },
    },
    navigationMenuContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          boxSizing: 'border-box',
          maxWidth: '100%',
        },
      },
    },
    navigationMenu: {
      configSet: MenuRow,
      configValues: {
        style: {
          container: {
            flexDirection: 'row',
            width: 'auto',
            padding: '0',
          },
        },
        itemInnerContainer: {
          itemSpacing: '8px',
        },
        item: {
          unselected: {
            style: {
              base: {
                _mobile_flexDirection: 'column',
                flexGrow: 0,
                padding: '0 8px',
              },
            },
          },
          selected: {
            style: {
              base: {
                _mobile_flexDirection: 'column',
                flexGrow: 0,
                padding: '0 8px',
              },
            },
          },
        },
        buttonScrollPane: {
          enableInitAnimation: false,
          contentContainer: {
            itemSpacing: '8px',
            style: {
              _mobile_padding: '0',
            },
          },
          scrollPaneContainer: {
            style: {
              padding: '0',
            },
          },
        },
      },
    },
    sportIcons: {
      configSet: SportIcons,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
